<template>
    <v-container fluid style="padding: 0px;">
        <v-card class="mx-auto pa-5" :max-width="$vuetify.breakpoint.smAndDown ? 900 : 800" outlined
            style="background: #F7F5F5; border-radius: 30px; border: 2px solid #05435B ;">
            <v-row>
                <v-col class="text-center">
                    <span v-if="!$vuetify.breakpoint.mobile" class="font-weight-black text-h5">Programa de
                        Trabajos</span>
                    <span v-else class="font-weight-black text-h6">Cumplimiento Programa de Trabajos</span>
                </v-col>
            </v-row>

            <!-- Campo Fecha Desde -->
            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6" style="display: flex; align-items: center;">
                    <span class="font-weight-black text-h7 mr-5">Desde</span>
                    <v-menu v-model="fromDateMenu1" :close-on-content-click="false" offset-y
                        transition="scale-transition" max-width="300px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="formattedDesde" placeholder="Inicio" prepend-icon="mdi-calendar"
                                clearable dense outlined readonly v-on="on" style="height: 35px;"></v-text-field>
                        </template>
                        <v-date-picker v-model="fechaDesde" locale="es" full-width hide-header color="#05435B"
                            @input="validateFechaDesde"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col v-else cols="6" style="display: flex; align-items: center;">
                    <v-menu v-model="fromDateMenu1" :close-on-content-click="false" offset-y
                        transition="scale-transition" max-width="300px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="formattedDesde" placeholder="Inicio" label="Desde"
                                prepend-icon="mdi-calendar" dense outlined readonly v-on="on"
                                style="height: 35px;"></v-text-field>
                        </template>
                        <v-date-picker v-model="fechaDesde" locale="es" full-width hide-header color="#05435B"
                            @input="validateFechaDesde"></v-date-picker>
                    </v-menu>
                </v-col>

                <!-- Campo Fecha Hasta -->
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6" style="display: flex; align-items: center;">
                    <span class="font-weight-black text-h7 mr-5">Hasta</span>
                    <v-menu v-model="fromDateMenu2" :close-on-content-click="false" offset-y
                        transition="scale-transition" max-width="300px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="formattedHasta" placeholder="Fin" prepend-icon="mdi-calendar"
                                clearable dense outlined readonly v-on="on" style="height: 35px;"></v-text-field>
                        </template>
                        <v-date-picker v-model="fechaHasta" locale="es" full-width hide-header color="#05435B"
                            @input="validateFechaHasta"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col v-else cols="6" style="display: flex; align-items: center;">
                    <v-menu v-model="fromDateMenu2" :close-on-content-click="false" offset-y
                        transition="scale-transition" max-width="300px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="formattedHasta" label="Hasta" placeholder="Fin"
                                prepend-icon="mdi-calendar" dense outlined readonly v-on="on"
                                style="height: 35px;"></v-text-field>
                        </template>
                        <v-date-picker v-model="fechaHasta" locale="es" full-width hide-header color="#05435B"
                            @input="validateFechaHasta"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>

            <!-- Campos de archivos -->
            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <span class="font-weight-black text-h7 mr-5">Archivo ODMs</span>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <v-file-input placeholder="ODMs.xlsx" clearable dense outlined style="height: 35px;" show-size
                        accept=".xls,.xlsx" @change="updateFile(0, $event)"></v-file-input>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
                    <v-file-input placeholder="ODMs.xlsx" label="Archivo ODMs" clearable dense outlined
                        style="height: 35px;" show-size accept=".xls,.xlsx"
                        @change="updateFile(0, $event)"></v-file-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <span class="font-weight-black text-h7 mr-5">Archivo SOLPEDS</span>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <v-file-input placeholder="SOLPEDS.xlsx" clearable dense outlined style="height: 35px;" show-size
                        accept=".xls,.xlsx" @change="updateFile(1, $event)"></v-file-input>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
                    <v-file-input placeholder="SOLPEDS.xlsx" label="Archivo SOLPEDS" clearable dense outlined
                        style="height: 35px;" show-size accept=".xls,.xlsx"
                        @change="updateFile(1, $event)"></v-file-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <span class="font-weight-black text-h7 mr-5">Archivo AVANCE INICIAL</span>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <v-file-input placeholder="AVANCE INICIAL.xlsx" clearable dense outlined style="height: 35px;"
                        show-size accept=".xls,.xlsx" @change="updateFile(2, $event)"></v-file-input>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
                    <v-file-input placeholder="AVANCE INICIAL.xlsx" label="Archivo AVANCE INICIAL" clearable dense
                        outlined style="height: 35px;" show-size accept=".xls,.xlsx"
                        @change="updateFile(2, $event)"></v-file-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6" style="display: flex; align-items: center;">
                    <span class="font-weight-black text-h7 mr-5">Archivo Entrega de Trabajos</span>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <v-file-input placeholder="Entrega de Trabajos.xlsx" clearable dense outlined style="height: 35px;"
                        accept=".xls,.xlsx" @change="updateFile(3, $event)" show-size></v-file-input>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
                    <v-file-input placeholder="Entrega de Trabajos.xlsx" label="Archivo Entrega de Trabajos" clearable
                        dense outlined style="height: 35px;" accept=".xls,.xlsx" @change="updateFile(3, $event)"
                        show-size></v-file-input>
                </v-col>

            </v-row>
            <v-row v-if="!$vuetify.breakpoint.mobile">
                <v-col cols="3" style="display: flex; align-items: center;">
                    <span class="font-weight-black text-h7 mr-5">Top de Proveedores</span>
                </v-col>
                <v-col cols="2"> <v-combobox v-model="value" :items="items" dense outlined
                        style="height: 35px;"></v-combobox>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="6" style="display: flex; align-items: center; padding: 0;">
                    <span class="font-weight-black text-h7 mr-5">¿Incluir indicardor de borrado pedido?</span>
                    <v-switch v-model="borradoPedido" color="#05435B" :label="borradoPedido ? 'Sí' : 'No'" hide-details
                        inset></v-switch>
                </v-col>
            </v-row>
            <v-row v-if="$vuetify.breakpoint.mobile">
                <v-col cols="8" style="display: flex; align-items: center;">
                    <span class="font-weight-black text-h7 mr-5">Top de Proveedores</span>
                </v-col>
                <v-col cols="4"> <v-combobox v-model="value" :items="items" dense outlined
                        style="height: 35px;"></v-combobox>
                </v-col>    
            </v-row>
            <v-row v-if="$vuetify.breakpoint.mobile">
                <v-col cols="8" style="display: flex; align-items: center;">
                    <span class="font-weight-black text-h7 mr-5">¿Incluir indicardor de borrado pedido?</span>
                </v-col>
                <v-col cols="4"> 
                    <v-switch v-model="borradoPedido" color="#05435B" :label="borradoPedido ? 'Sí' : 'No'" hide-details
                        inset></v-switch>
                </v-col>    
            </v-row>
            <v-row :style="{ marginTop: '0px', marginBottom: $vuetify.breakpoint.smAndDown ? '10px' : '0px' }">
                <v-col cols="12" style="display: flex; justify-content: center; padding-top: 0px;">
                    <v-btn color="success" class="mt-4 rounded-button" @click="evaluarCumplimiento()">
                        Obtener Cumplimiento
                    </v-btn>
                </v-col>
            </v-row>
            <v-row style="margin-top: 0px; margin-bottom: 10px;" v-if="archivosGenerados.length > 0">
                <v-spacer></v-spacer>
                <v-col cols="12" class="d-flex align-center">
                    <v-spacer></v-spacer>
                    <v-col cols="8">
                        <span class="font-weight-black text-h8">Archivos generados.zip</span>
                    </v-col>

                    <!-- Botón para descargar -->
                    <v-col cols="2" class="text-right">
                        <v-btn density="compact" @click="descargarTodos(archivosGenerados)">
                            <v-icon style="color:#04395a">mdi-folder-zip</v-icon>
                        </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import apiService from "@/services/apiService";
import SwalService from '@/services/swalService'; // Ajusta la ruta según tu proyecto

export default {
    data() {
        return {
            fromDateMenu1: false, // Controla el menú de la fecha "Desde"
            fromDateMenu2: false, // Controla el menú de la fecha "Hasta"
            fechaDesde: null, // Fecha seleccionada para "Desde"
            fechaHasta: null, // Fecha seleccionada para "Hasta"
            borradoPedido: true,
            valid: false,
            items: Array.from({ length: 100 }, (_, i) => i + 1), // Números del 1 al 100
            value: 15,
            files: [null, null, null], // Archivos: [ODM, SOLPEDS, AVANCE INICIAL]
            archivosGenerados: []
        };
    },
    computed: {
        formattedDesde() {
            return this.fechaDesde
                ? new Date(this.fechaDesde + 'T00:00:00').toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })
                : "";
        },
        formattedHasta() {
            return this.fechaHasta
                ? new Date(this.fechaHasta + 'T00:00:00').toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })
                : "";
        },
    },
    methods: {
        validateFechaDesde(value) {
            if (this.fechaHasta && new Date(value) > new Date(this.fechaHasta)) {
                this.fechaDesde = null;
                alert("La fecha de inicio no puede ser mayor que la fecha de fin.");
            } else {
                this.fechaDesde = value;
            }
            this.fromDateMenu1 = false;
        },
        validateFechaHasta(value) {
            if (this.fechaDesde && new Date(value) < new Date(this.fechaDesde)) {
                this.fechaHasta = null;
                alert("La fecha de fin no puede ser menor que la fecha de inicio.");
            } else {
                this.fechaHasta = value;
            }
            this.fromDateMenu2 = false;
        },
        updateFile(index, file) {
            // Actualiza el archivo correspondiente en el arreglo `files`
            this.files[index] = file;
        },
        isExcelFile(file) {
            // Verifica si el archivo tiene extensión válida
            const allowedExtensions = [".xls", ".xlsx"];
            const fileName = file.name.toLowerCase();
            return allowedExtensions.some(ext => fileName.endsWith(ext));
        },

        async evaluarCumplimiento() {
            this.archivosGenerados = [];
            try {
                SwalService.loading('Evaluando Cumplimiento...', 'Por favor espere.');
                if (this.fechaDesde == null || this.fechaHasta == null || !this.files.every(file => file !== null)) {
                    SwalService.close();
                    await new Promise(resolve => setTimeout(resolve, 100));
                    await SwalService.alert('Debe cargar todos los campos para poder continuar')
                    return;
                }
                // Realizar solicitud POST al backend para autenticación
                const response = await apiService.post("/programa-trabajos/inicia-proceso", {
                    fechaInicio: this.fechaDesde,
                    fechaFin: this.fechaHasta,
                    indicadorBorrado: this.borradoPedido,
                    topProveedores: this.value,
                    idProceso: null,
                    tipoProceso: 4,
                    idUsuario: 2
                });

                // Maneja la respuesta
                const respuesta = response.data;
                if (respuesta.success) {
                    const datos = {
                        archivos: [
                            {
                                id: null,
                                nombreLogico: null,
                                nombreFisico: null,
                                ruta: null,
                                fechaCarga: null,
                                proceso: respuesta.proceso,
                                tipoArchivo: 1,
                            },
                            {
                                id: null,
                                nombreLogico: null,
                                nombreFisico: null,
                                ruta: null,
                                fechaCarga: null,
                                proceso: respuesta.proceso,
                                tipoArchivo: 2,
                            },
                            {
                                id: null,
                                nombreLogico: null,
                                nombreFisico: null,
                                ruta: null,
                                fechaCarga: null,
                                proceso: respuesta.proceso,
                                tipoArchivo: 3,
                            },
                            {
                                id: null,
                                nombreLogico: null,
                                nombreFisico: null,
                                ruta: null,
                                fechaCarga: null,
                                proceso: respuesta.proceso,
                                tipoArchivo: 10,
                            },
                        ],
                    };

                    // Crear un FormData para enviar los archivos y los datos juntos
                    const formData = new FormData();

                    // Agregar los archivos a FormData (asegurando que los archivos sean seleccionados por el usuario)
                    formData.append("files", this.files[0]); // Archivo ODMs
                    formData.append("files", this.files[1]); // Archivo SOLPEDS
                    formData.append("files", this.files[2]); // Archivo Avance Inicial
                    formData.append("files", this.files[3]);

                    // Agregar los datos serializados en formato JSON
                    formData.append("datosAdjunto", JSON.stringify(datos.archivos));

                    // Enviar los datos y los archivos al endpoint
                    const response2 = await apiService.post("/files/upload", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });

                    // Manejar la respuesta de la carga de archivos
                    const uploadResponse = response2.data;

                    const response3 = await apiService.post("/programa-trabajos/ejecuta-script", {
                        fechaInicio: this.fechaDesde,
                        fechaFin: this.fechaHasta,
                        indicadorBorrado: this.borradoPedido,
                        topProveedores: this.value,
                        idProceso: respuesta.proceso.idProceso,
                        tipoProceso: 4,
                        idUsuario: 2
                    });

                    const ejecutaScript = response3.data;
                    if (ejecutaScript.success) {
                        this.archivosGenerados = ejecutaScript.archivos;
                        SwalService.close();
                        await new Promise(resolve => setTimeout(resolve, 100));
                        SwalService.success('Evaluación de Cumplimiento Completada', 'El archivo simulado ya se encuentra disponible para descargar');
                    } else {
                        SwalService.close();
                        await new Promise(resolve => setTimeout(resolve, 100));
                        SwalService.error(ejecutaScript.error);
                    }

                } else {
                    SwalService.close();
                }

            } catch (error) {
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
                SwalService.error('Error al cargar datos', 'Ocurrió un problema.');
            }
        },
        async descargar(id, fileName) {
            try {
                SwalService.loading('Descargando...', 'Por favor espere.');
                await apiService.downloadFile(`/files/${id}`, fileName);
                console.log('Archivo descargado exitosamente.');
                SwalService.close();
            } catch (error) {
                console.error('Error al descargar el archivo:', error);
                SwalService.close();
                SwalService.success('Simulación Completada', 'El archivo simulado ya se encuentra disponible para descargar');
                SwalService.error('No se pudo descargar el archivo. Intenta nuevamente.');
            }
        },
        async descargarTodos(ids) {
            try {
                SwalService.loading('Descargando...', 'Por favor espere.');
                await apiService.downloadFiles(`/files/download`, ids.map(archivo => archivo.id), 'archivosGenerados.zip');
                console.log('Archivo descargado exitosamente.');
                SwalService.close();
            } catch (error) {
                console.error('Error al descargar el archivo:', error);
                SwalService.close();
                SwalService.success('Simulación Completada', 'El archivo simulado ya se encuentra disponible para descargar');
                SwalService.error('No se pudo descargar el archivo. Intenta nuevamente.');
            }
        }
    },
};
</script>

<style scoped>
.v-menu__content {
    z-index: 9000 !important;
    position: absolute !important;
}

.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
}

@media (max-width: 600px) {
    .v-application .pa-5 {
        padding: 5px !important;
    }
}
</style>